import * as numeral from 'numeral'
import dayjs from 'dayjs'

// dayjs plugin extensions (utc, timezone, customParseFormat, isSameOrBefore,
// isSameOrAfter, localizedFormat) are applied via the side-effect import of
// @pushly/aqe/lib/dayjs-setup at the app entry. This function only handles
// runtime locale loading for numeral and dayjs.
export const setupLocalization = async () => {
    let locale = (navigator as any).userLanguage || navigator.language
    locale = locale.toLowerCase()

    try {
        await import(`numeral/locales/${locale}.js`)
        numeral.locale(locale)
    } catch {}

    try {
        await import(`dayjs/locale/${locale}.js`)
        dayjs.locale(locale)
    } catch {}
}
